import React from 'react';
import AccordionReferralCard from 'components/card/AccordionReferralCard';
import { AssetWitenes, EntityType, Referral } from 'types';
import { UserCard } from 'components/card/UserCard';

interface WitnessCardProps {
  referralData?: Referral | null
  referralId?: string;
  handleButtonClick: (type:EntityType) => void;
  handleEdit: (type:EntityType, witness: AssetWitenes) => void;
  handleDelete: (id: string, type:EntityType) => void;
  handleUserView: (user: any, title: string, description: string, children?: React.ReactNode) => void;
}

export default function WitnessCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  handleDelete,
  handleUserView
}: WitnessCardProps) {
  return (
    <AccordionReferralCard
      title={`Witness - ${referralData?.witnesses?.length || 0}`}
      buttonText="Add Witness"
      onButtonClick={() => handleButtonClick("witness")}
      disabled={
        !referralData ||
          [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.witnesses && referralData.witnesses.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.witnesses.map((witness) => (
            <UserCard
              key={witness.id}
              avatarUrl=""
              date={""}
              name={witness?.person?.full_name as string}
              role={witness?.person?.region as string}
              time={""}
              onDelete={() => handleDelete(witness?.id as string, "witness")}
              onEdit={() => handleEdit("witness", witness)}
              user={witness.person}
              title="Witness Details"
              description="Detailed information about witness"
             disabled={
                      ![
                        "Investigation Ongoing",
                        "Pending",
                        "Prohibition On Revision",
                      ].includes(referralData?.action_status as string)
                    }
              onView={() => handleUserView(
                witness.person,
                "Witness Details",
                "Detailed information about witness",
                <div className="space-y-3">
                  {witness?.testimony_summary && (
                    <div>
                      <h4 className="font-semibold text-gray-700">
                        Testimony Summary
                      </h4>
                      <p className="text-gray-600 whitespace-pre-wrap">
                        {witness.testimony_summary}
                      </p>
                    </div>
                  )}
                </div>
              )}
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No witnesses added yet
        </div>
      )}
    </AccordionReferralCard>
  );
}